import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { TabContext, TabPanel } from "@mui/lab";
import { Box, Button, Grid, Stack, Tab, Typography } from "@mui/material";

import imageExample6 from "assets/images/turkPipelinesImages/0-xMaFF2hSXpf_kIfG.jpeg";
import imageExample5 from "assets/images/turkPipelinesImages/test-intelligenza-sociale.jpeg";
import imageExample1 from "assets/images/turkPipelinesImages/Top-25-API-Testing-Tools.png";
import imageExample2 from "assets/images/turkPipelinesImages/Top-25-API-Testing-Tools.png";
import imageExample3 from "assets/images/turkPipelinesImages/Top-25-API-Testing-Tools.png";
import imageExample4 from "assets/images/turkPipelinesImages/Top-25-API-Testing-Tools.png";
import { Tabs, useTabValue } from "common/components/Tabs/Tabs";
import { useAppDialog } from "hooks/useAppDialog";
import { GreyBox } from "styles/App.styles";
import { VehicleAngleCard } from "./Cards/VehicleAngleCard";

export interface VehicleAngle {
  url: string;
  angle: string;
  checked: boolean;
}

export const VehicleAngleClaim = (): JSX.Element => {
  const { t } = useTranslation();
  const { openDialog, Dialog, dialogProps } = useAppDialog();
  const [selectedImage, setSelectedImage] = useState<VehicleAngle>();
  const [tabValue, setTabValue] = useTabValue<"Commands" | "Instructions">(
    "Commands"
  );

  // TODO: replace values with values from Api when it is available
  const instructionsText =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla metus justo, accumsan vel turpis ac, vulputate suscipit dui. Quisque quis risus venenatis felis cursus mattis. Duis tortor diam, dictum eu viverra vitae, suscipit et risus. Sed in pellentesque erat, et auctor lectus. Ut dignissim tortor egestas nulla vulputate, in dapibus magna fermentum. Nulla varius elit non magna mollis sagittis. Nulla suscipit tellus non nisi tristique condimentum. Nunc et tellus in tellus semper sollicitudin quis eu velit. Etiam vitae venenatis nibh, quis molestie leo. Donec a tincidunt dui. Quisque commodo magna in fringilla maximus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum turpis lacus, accumsan id magna vitae, malesuada feugiat ex. Aenean rutrum pharetra dolor, dapibus ultricies ex dapibus nec. Phasellus iaculis ante at sem accumsan dapibus. Sed ornare nulla vel tortor luctus pretium. Mauris et eros nec tortor feugiat malesuada faucibus ut lacus. In id tortor interdum, condimentum felis a, pellentesque orci. Vestibulum luctus egestas metus. Nunc vitae suscipit tellus. Cras dapibus enim eget nulla volutpat tristique. Maecenas non arcu nec erat sagittis aliquet ac ac lorem. Nunc interdum ornare pulvinar. Donec eu mi auctor, pharetra libero eu, eleifend lorem. Fusce id felis malesuada, ullamcorper neque sed, eleifend nunc. Nam tempus bibendum ex, vitae blandit libero venenatis at. Morbi in dapibus orci, at fermentum mauris. Nunc tincidunt mi ut gravida viverra. Nulla facilisi. Duis elementum, justo quis condimentum pharetra, metus erat varius lacus, nec blandit leo erat nec justo. Mauris vulputate diam ac mi hendrerit, at tempus tortor porta. Quisque tristique elit non dolor convallis elementum sit amet vel felis. Ut erat risus, eleifend eu ornare sit amet, euismod ut ipsum. Donec lobortis suscipit quam in pretium. Donec tristique odio vitae dolor viverra, egestas vehicula metus consectetur. Fusce tempor eget elit sit amet iaculis. Suspendisse lobortis cursus eros, eleifend porttitor tortor pulvinar ac. Integer venenatis rutrum lectus, et bibendum lacus elementum at. Nullam in euismod purus. Morbi convallis, lorem eu rhoncus venenatis, magna augue mattis est, sed congue erat ex nec tortor. Quisque non pharetra tellus, sit amet interdum turpis. Nunc eleifend turpis elementum ipsum rutrum feugiat. Duis auctor eu nulla vel fringilla. Nulla tincidunt posuere lorem sed bibendum.";
  const imageArray: Array<VehicleAngle> = [
    {
      url: imageExample1,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample2,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample3,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample4,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample5,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample6,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample1,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample1,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample1,
      angle: "unknown",
      checked: false,
    },
    {
      url: imageExample1,
      angle: "unknown",
      checked: false,
    },
  ];

  const onVehicleAngleClick = useCallback(
    (selectedImage: VehicleAngle) => {
      setSelectedImage(selectedImage);
      openDialog();
    },
    [openDialog]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={9} sx={{ overflow: "auto", height: "100%" }}>
        <Grid container spacing={2} sx={{ pr: "2px", pb: 2 }}>
          {imageArray.map((image, index) => (
            <Grid key={index} item xs={4}>
              <VehicleAngleCard
                renderImage={image}
                minAngleSelectWidth={150}
                sx={{ maxWidth: 400 }}
                sxCardMediaProps={{ minHeight: 180, maxHeight: 180 }}
                index={index}
                onImageClick={onVehicleAngleClick}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={3} sx={{ overflow: "hidden", height: "100%" }}>
        <Stack sx={{ maxHeight: "100%" }}>
          <TabContext value={tabValue}>
            <Tabs onChange={setTabValue}>
              <Tab label={t("Commands")} value="Commands" />
              <Tab label={t("Instructions")} value="Instructions" />
            </Tabs>
            <Box sx={{ overflow: "auto" }}>
              <TabPanel value="Commands">
                <Stack spacing={3} m={3}>
                  <Typography variant="body1" pl={2}>
                    {t("Angle")}
                  </Typography>
                  <GreyBox sx={{ height: "100%" }} elevation={0}>
                    <Stack spacing={3} m={3}>
                      <Button
                        variant="contained"
                        size="medium"
                        disableElevation
                      >
                        {t("Front")}
                      </Button>
                      <Button
                        variant="contained"
                        size="medium"
                        disableElevation
                      >
                        {t("Rear")}
                      </Button>
                      <Button
                        variant="contained"
                        size="medium"
                        disableElevation
                      >
                        {t("Left")}
                      </Button>
                      <Button
                        variant="contained"
                        size="medium"
                        disableElevation
                      >
                        {t("Right")}
                      </Button>
                    </Stack>
                  </GreyBox>
                </Stack>
              </TabPanel>
              <TabPanel value="Instructions">
                <Typography variant="body1" p={1}>
                  {instructionsText}
                </Typography>
              </TabPanel>
            </Box>
          </TabContext>
          <Stack spacing={2} paddingY={2}>
            <Button variant="contained" size="medium" disableElevation>
              {t("CompleteJob")}
            </Button>
            <Button size="medium">{t("UnclaimJob")}</Button>
          </Stack>
        </Stack>
      </Grid>
      <Dialog
        {...dialogProps}
        title={t("VehicleAngle")}
        loading={false}
        onSubmit={() => null}
        actionText={t("Save")}
        maxWidth="md"
      >
        <VehicleAngleCard
          renderImage={selectedImage ?? { url: "", angle: "", checked: false }}
          disableActionArea
          minAngleSelectWidth={250}
          sx={{ width: "100%", flex: 1 }}
          sxCardMediaProps={{ minHeight: 450, maxHeight: 450 }}
        />
      </Dialog>
    </Grid>
  );
};
